import { CSSProperties } from 'react'
import {
  Button as BaseButton,
  ButtonProps as BaseProps,
  Image,
} from 'react-bootstrap'

export interface ButtonProps extends BaseProps {
  text: string | number | JSX.Element
  icon?: string
  handleClick?: () => void
  loading?: boolean
  class?: string
  style?: CSSProperties
}

interface LoadingModeType {
  mode?: 'dark' | 'light'
}

export const ButtonLoading = (props: LoadingModeType): JSX.Element => {
  return (
    <div
      className={`spinner center ${
        props.mode === 'light' ? 'spinner-light' : ''
      }`}
    >
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
      <div className="spinner-blade" />
    </div>
  )
}

export const Button = (props: ButtonProps): JSX.Element => {
  return (
    <div
      className={`sys-button ${props.class ? props.class : ''} ${
        props.loading ? ' button-loading' : ''
      }`}
    >
      <BaseButton
        variant={props.variant}
        size={props.size}
        className="custom-button"
        onClick={props.handleClick}
        disabled={props.disabled}
        style={props.style}
      >
        {props.loading ? (
          <ButtonLoading mode="light" />
        ) : (
          <>
            <span className={'text-button' + (props.icon ? ' has-icon' : '')}>
              {props.text}
            </span>
            {props.icon ? (
              <Image src={props.icon} className="icon-button" />
            ) : (
              ''
            )}
          </>
        )}
      </BaseButton>
    </div>
  )
}
